/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationStatus } from './IntegrationStatus';
import {
    IntegrationStatusFromJSON,
    IntegrationStatusFromJSONTyped,
    IntegrationStatusToJSON,
    IntegrationStatusToJSONTyped,
} from './IntegrationStatus';
import type { ProjectData } from './ProjectData';
import {
    ProjectDataFromJSON,
    ProjectDataFromJSONTyped,
    ProjectDataToJSON,
    ProjectDataToJSONTyped,
} from './ProjectData';

/**
 * 
 * @export
 * @interface ProjectWithIntegrations
 */
export interface ProjectWithIntegrations {
    /**
     * 
     * @type {ProjectData}
     * @memberof ProjectWithIntegrations
     */
    projectData?: ProjectData;
    /**
     * 
     * @type {Array<IntegrationStatus>}
     * @memberof ProjectWithIntegrations
     */
    integrationStatuses?: Array<IntegrationStatus>;
}

/**
 * Check if a given object implements the ProjectWithIntegrations interface.
 */
export function instanceOfProjectWithIntegrations(value: object): value is ProjectWithIntegrations {
    return true;
}

export function ProjectWithIntegrationsFromJSON(json: any): ProjectWithIntegrations {
    return ProjectWithIntegrationsFromJSONTyped(json, false);
}

export function ProjectWithIntegrationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectWithIntegrations {
    if (json == null) {
        return json;
    }
    return {
        
        'projectData': json['projectData'] == null ? undefined : ProjectDataFromJSON(json['projectData']),
        'integrationStatuses': json['integrationStatuses'] == null ? undefined : ((json['integrationStatuses'] as Array<any>).map(IntegrationStatusFromJSON)),
    };
}

export function ProjectWithIntegrationsToJSON(json: any): ProjectWithIntegrations {
    return ProjectWithIntegrationsToJSONTyped(json, false);
}

export function ProjectWithIntegrationsToJSONTyped(value?: ProjectWithIntegrations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectData': ProjectDataToJSON(value['projectData']),
        'integrationStatuses': value['integrationStatuses'] == null ? undefined : ((value['integrationStatuses'] as Array<any>).map(IntegrationStatusToJSON)),
    };
}

